import LockIcon from '@mui/icons-material/Lock';
import React from 'react';
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers';
import { HeaderContent, Logo, PaymentHeader, SecurityNotice } from '../styles';

export const PageHeader: React.FC = () => (
  <PaymentHeader>
    <HeaderContent>
      <Logo src={toAbsoluteUrl('/media/svg/logos/logo-jusfy.svg')} alt="Jusfy" />
      <SecurityNotice>
        <LockIcon />
        <span>Compra segura | Jusfy {new Date().getFullYear()}</span>
      </SecurityNotice>
    </HeaderContent>
  </PaymentHeader>
);
